// extracted by mini-css-extract-plugin
module.exports = {"container":"prizes_container__397xa","block":"prizes_block__2Elkk","block__title":"prizes_block__title__2bpZV"};